module.exports = __webpack_public_path__ + "static/media/up-arrow-white.a58c8c3d.svg";